// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EuroCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/EuroCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var EuroCircleOutlined = function EuroCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EuroCircleOutlinedSvg
  }));
};

EuroCircleOutlined.displayName = 'EuroCircleOutlined';
export default React.forwardRef(EuroCircleOutlined);